import axios from 'axios'
import Vue from 'vue'
import store from '~/store'
import _ from 'lodash'

import {
  MODULE_TYPE_SZAFA,
  MODULE_TYPE_GARDEROB_L_LEFT,
  MODULE_TYPE_GARDEROB_L_RIGHT,
  MODULE_TYPE_GARDEROB_U,
  GLOBAL_MODULE_TYPE_SZAFY,
  GLOBAL_MODULE_TYPE_GARDEROBY,
  globalType
} from '../../resource/ModuleTypes'

import {
  WIDTH_ANGLES_MODULE,
  WIDTH_MIN_MODULE,
  WIDTH_MAX_MODULE,
  WIDTH_ANGLE_MODULE
} from '../../resource/ModuleParams'

// state
export const state = {
  modules: [],
  moduleCollection: []
}

// getters
export const getters = {
  moduleCollection: state => {
    state.moduleCollection.key = getRandomKey()

    return state.moduleCollection
  },

  moduleCollectionChoose: state => {
    return state.moduleCollection.find(module => module.information.chooseModule === true)
  },

  modulesIdentifier: (state) => (getters) => {
    let moduleIdenfier = state.modules.find(module => module.id === parseInt(getters)).identifier

    return state.modules.filter(module => module.identifier === parseInt(moduleIdenfier))
  },

  /**
   * Return sum width
   *
   * @param state
   * @returns {number}
   */
  modulesWidth: state => {
    return state.moduleCollection.length ? state.moduleCollection[0].information.width : 0
  },

  moduleChooseCombination: state => {
    let moduleCollection = getters.moduleCollectionChoose(state)

    return state.moduleCollection.length ? Object.values(moduleCollection.information.combination).slice().reverse() : []
  },

  getModuleById: state => (id) => {
    return state.modules.find(module => module.id === id)
  }
}

// mutations
export const mutations = {
  setModule (state, module) {
    module.answers = []

    state.modules.push(module)
  },

  fetchModules (state, { modules }) {
    state.modules = modules
  },

  updateModule (state, module) {
    var foundIndex = state.modules.findIndex(x => x.id === parseInt(module.id))

    Vue.set(state.modules, foundIndex, module)
  },

  deleteModule (state, id) {
    var foundIndex = state.modules.findIndex(x => x.id === parseInt(id))

    state.modules.splice(foundIndex, 1)
  },

  setAnswerScore (state, payload) {
    var foundIndexModule = getModuleIndex(payload)

    var foundIndexAnswer = getAnswerIndexInModules(payload)

    state.modules[foundIndexModule].answers[foundIndexAnswer].pivot.score = payload.score
  },

  setModuleAccessories (state, payload) {
    var foundIndexModule = getModuleIndex(payload)

    payload.accessory.pivot.color_type = payload.color_type

    state.modules[foundIndexModule].accessories.push(payload.accessory)
  },

  updateModuleAccessories (state, payload) {
    var indexModule = getModuleIndex(payload)

    var indexAccessory = getAccessoryIndexInModules(payload)

    state.modules[indexModule].accessories[indexAccessory].pivot.quantity = payload.quantity
  },

  deleteModuleAccessories (state, payload) {
    var indexModule = getModuleIndex(payload)

    var indexAccessory = getAccessoryIndexInModules(payload)

    state.modules[indexModule].accessories.splice(indexAccessory, 1)
  },

  updateModuleCollection (state, module) {
    var foundModuleClick = state.moduleCollection.findIndex(x => x.information.id === module.information.id)

    var foundModuleActiveNow = state.moduleCollection.findIndex(x => x.information.chooseModule === true)

    Vue.set(state.moduleCollection[foundModuleActiveNow].information, 'chooseModule', false)

    Vue.set(state.moduleCollection[foundModuleClick].information, 'chooseModule', true)

    state.moduleCollection.key = getRandomKey()

    store.commit('moduleCurrent/resetModulePosition', state.moduleCollection[foundModuleClick].data)
  },

  clearModuleCollection (state) {
    state.moduleCollection = []
  }
}

// actions
export const actions = {
  /**
   * Fetch all modules
   *
   * @param commit
   * @returns {Promise<void>}
   */
  async fetchAllModules ({ commit }) {
    try {
      var szafy = []

      var garderoby = []

      await indexModules(GLOBAL_MODULE_TYPE_SZAFY).then(request => {
        szafy = request
      })

      await indexModules(GLOBAL_MODULE_TYPE_GARDEROBY).then(request => {
        garderoby = request
      })

      let data = szafy.concat(garderoby)

      commit('fetchModules', { modules: data })
    } catch (e) {
    }
  },

  /**
   * Fetch module by type
   *
   * @param commit
   * @param payload
   */
  fetchModulesByType ({ commit }, payload) {
    axios.get('/api/module', {
      params: {
        type_module: globalType(payload)
      }
    }).then(({ data }) => {
      commit('fetchModules', { modules: data })
    })
  },

  async setModule ({ commit }, module) {
    try {
      commit('setModule', module)
    } catch (e) {
    }
  },

  async updateModule ({ commit }, module) {
    try {
      commit('updateModule', module)
    } catch (e) {
    }
  },

  async deleteModule ({ commit }, id) {
    try {
      commit('deleteModule', id)
    } catch (e) {
    }
  },

  async sendModuleCollection ({ dispatch, rootState }, payload) {
    if (rootState.moduleCurrent.moduleType === MODULE_TYPE_SZAFA) {
      dispatch('sendModuleCollectionSzafa', payload)
    } else {
      dispatch('sendModuleCollectionGarderoby', payload)
    }
  },

  sendModuleCollectionSzafa ({ state, commit }, payload) {
    let moduleFromServer = []

    commit('doorCurrent/CLEAR_DOOR_CURRENT', '', { root: true })

    state.moduleCollection = []

    axios.post('/api/module/size/szafy/build', {
      combination: payload.combination,
      answers: payload.answers,
      type: GLOBAL_MODULE_TYPE_SZAFY
    }).then(({ data }) => {
      moduleFromServer = data.map(collection => {
        collection.information.chooseModule = false
        collection.information.id = getRandomKey()
        collection.data.reverse()
        collection.data = collection.data.map(modules => {
          modules = modules.map(module => {
            let data = state.modules.find(moduleFind => moduleFind.id === parseInt(module.module_id))
            data.score = module.score

            return data
          })

          return modules
        })

        return collection
      })

      moduleFromServer.sort((a, b) => (a.information.score / a.data.length > b.information.score / b.data.length) ? -1 : 1)

      if (moduleFromServer.length) {
        moduleFromServer[0].information.chooseModule = true

        state.moduleCollection = moduleFromServer
      }
    })
  },

  sendModuleCollectionGarderoby ({ state, rootState, commit }, payload) {
    payload.combination = checkGarderobySendCombination(payload.combination,
      rootState.moduleCurrent.moduleType,
      countCanBeModule(rootState.questions.sizeModuleCorrect, rootState.moduleCurrent.moduleType))

    // payload.combination = checkCominationOnEmpty(payload.combination, rootState.moduleCurrent.moduleType)

    commit('doorGarderobyCurrent/CLEAR_DOOR_CURRENT', '', { root: true })

    setTimeout(() => {
      axios.post('/api/module/size/garderoby/build', {
        combination: payload.combination,
        answers: payload.answers,
        type: 'garderoby'
      }).then(({ data }) => {
        data = Object.values(data)

        data = data.map(item => {
          item.information.chooseModule = false
          item.information.id = getRandomKey()
          return item
        })
        data[0].information.chooseModule = true
        state.moduleCollection = data
      })
    }, 1000)
  },

  async setAnswerScore ({ commit }, payload) {
    try {
      commit('setAnswerScore', payload)
    } catch (e) {
    }
  },

  async setModuleAccessories ({ commit }, payload) {
    try {
      commit('setModuleAccessories', payload)
    } catch (e) {
    }
  },

  async updateModuleAccessories ({ commit }, payload) {
    try {
      commit('updateModuleAccessories', payload)
    } catch (e) {
    }
  },

  async deleteModuleAccessories ({ commit }, payload) {
    try {
      commit('deleteModuleAccessories', payload)
    } catch (e) {
    }
  },

  async updateModuleCollection ({ commit }, module) {
    try {
      commit('updateModuleCollection', module)
    } catch (e) {
    }
  }
}

function checkGarderobySendCombination (combination, type, countCanBeModule) {
  // if (countCanBeModule.middle > 0) {
  //   if (combination.some(item => !item.middle)) {
  //     findAndAddCombination(combination, 'middle')
  //   }
  // } else if (countCanBeModule.middle === 0) {
  //   if (!combination.length) {
  //     combination.push({ middle: {} })
  //   } else {
  //     combination.map(item => {
  //       item.middle = {}
  //       return item
  //     })
  //   }
  // }

  helpFunctionForCombination(combination, countCanBeModule, 'middle')
  helpFunctionForCombination(combination, countCanBeModule, 'left')
  helpFunctionForCombination(combination, countCanBeModule, 'right')

  return combination >= 3 ? combination : createCombination(combination)
}

function helpFunctionForCombination (combination, countCanBeModule, choose) {
  if (countCanBeModule[choose] > 0) {
    if (combination.some(item => !item[choose])) {
      findAndAddCombination(combination, choose)
    }
  } else if (countCanBeModule[choose] === 0) {
    if (!combination.length) {
      combination.push({ [choose]: {} })
    } else {
      combination.map(item => {
        item[choose] = {}
        return item
      })
    }
  }
}

function findAndAddCombination (combination, choose) {
  let find = {}

  combination.forEach((i) => {
    if (i[choose]) {
      if (!Object.keys(find).length || (Object.keys(i[choose]).length < Object.keys(find).length)) {
        find = i[choose]
      }
    }
  })

  combination = combination.map(item => {
    if (!item[choose]) item[choose] = find
    return item
  })
}

function createCombination (combination) {
  for (var i = 0; i < combination.length; i++) {
    if (combination[i].left) {
      if (helpCreateCombination(combination, 'left', combination[i].left)) {
        combination.push(helpCreateCombination(combination, 'left', combination[i].left))

        break
      }
    } else if (combination[i].right) {
      if (helpCreateCombination(combination, 'right', combination[i].right)) {
        combination.push(helpCreateCombination(combination, 'right', combination[i].right))

        break
      }
    }
  }

  return combination
}

function helpCreateCombination (combination, choose, newSide) {
  let createdCombination = {}

  let reverseChoose = choose === 'left' ? 'right' : 'left'

  createdCombination[choose] = newSide

  for (var i = 0; i < combination.length; i++) {
    if (combination[i].middle) {
      createdCombination.middle = combination[i].middle

      if (combination[i][reverseChoose]) {
        for (var j = 0; j < combination.length; j++) {
          createdCombination[reverseChoose] = combination[i][reverseChoose]

          if (!combination.find(item => _.isEqual(createdCombination, item))) {
            return createdCombination
          }
        }
      } else {
        if (!combination.find(item => _.isEqual(createdCombination, item))) {
          return createdCombination
        }
      }
    }
  }

  return false
}

function checkItemCount (combination, middle, side) {
  middle = middle.filter(item => item)

  side = side.filter(item => item)

  let findItem = {}

  if (side.length > middle.length) {
    findItem = helpCheckItemCount(middle, 100)

    if (!findItem || !Object.keys(findItem).length) {
      findItem = helpCheckItemCount(middle, 50)
    }
  } else if (side.length < middle.length) {
    findItem = helpCheckItemCount(side, 100)

    if (!findItem || !Object.keys(findItem).length) {
      findItem = helpCheckItemCount(side, 50)
    }
  }

  return findItem || {}
}

function helpCheckItemCount (choose, count) {
  return choose.find(item => {
    for (const property in item) {
      if (item[property] === count) return true
    }
  })
}

/**
 * Return all module by module id
 *
 * @param {Object} payload
 * @returns {number}
 */
function getModuleIndex (payload) {
  return state.modules.findIndex(x => x.id === parseInt(payload.module.id))
}

/**
 * Return accessories by module id
 *
 * @param {Object} payload
 * @returns {*}
 */
function getAccessoryIndexInModules (payload) {
  return state.modules[getModuleIndex(payload)].accessories.findIndex(x => x.id === parseInt(payload.accessory.id))
}

/**
 * Return answer by module id
 *
 * @param {Object} payload
 * @returns {number}
 */
function getAnswerIndexInModules (payload) {
  return state.modules[getModuleIndex(payload)].answers.findIndex(x => x.id === parseInt(payload.answer.id))
}

/**
 * Retrun unique key
 *
 * @returns {string}
 */
function getRandomKey () {
  return Math.random().toString(36).substring(7)
}

/**
 * Index modules help function by fetch all
 *
 * @param type
 * @returns {Promise<void>}
 */
async function indexModules (type) {
  const { data } = await axios.get('/api/module', {
    params: {
      type_module: type
    }
  })

  return data
}

/**
 * Create array of min length 3
 *
 * @param combination
 * @param type
 * @returns {*}
 */
function checkCominationOnEmpty (combination, type) {
  if (combination.length <= 3) return combination

  let findMin = []

  let findMax = []

  if (type === MODULE_TYPE_GARDEROB_L_LEFT) {
    findMin = combination.filter(item => !Object.keys(item.left).length || !Object.keys(item.middle).length)

    findMax = combination.filter(item => Object.keys(item.left).length && Object.keys(item.middle).length)
  } else if (type === MODULE_TYPE_GARDEROB_L_RIGHT) {
    findMin = combination.filter(item => !Object.keys(item.right).length || !Object.keys(item.middle).length)

    findMax = combination.filter(item => Object.keys(item.right).length && Object.keys(item.middle).length)
  } else {
    findMin = combination.filter(item => !Object.keys(item.left).length || !Object.keys(item.right).length || !Object.keys(item.middle).length)

    findMax = combination.filter(item => Object.keys(item.left).length && Object.keys(item.right).length && Object.keys(item.middle).length)
  }

  if (findMax.length === 0) {
    return findMin
  } else if (findMax.length < 3) {
    for (var i = 0; i < findMin.length; i++) {
      findMax.push(findMin[i])
      if (findMax.length === 3) break
    }
    return findMax
  } else {
    return findMax
  }
}

function countCanBeModule (sizeModuleCorrect, type) {
  let count = type === MODULE_TYPE_GARDEROB_U ? WIDTH_ANGLES_MODULE : WIDTH_ANGLE_MODULE

  return {
    middle: Math.floor((sizeModuleCorrect.middle - count / 10) / (WIDTH_MIN_MODULE / 10)),
    left: Math.floor((sizeModuleCorrect.left - WIDTH_MAX_MODULE / 10) / (WIDTH_MIN_MODULE / 10)),
    right: Math.floor((sizeModuleCorrect.right - WIDTH_MAX_MODULE / 10) / (WIDTH_MIN_MODULE / 10))
  }
}



// WEBPACK FOOTER //
// ./resources/js/store/modules/modules.js